// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"f204ec49","453":"9eb00ecb","490":"36bc662a"}[chunkId] + ".chunk.js";
};